export default {
  USER_SET_DATA: "USER_SET_DATA",
  USER_LOGOUT: "USER_LOGOUT",
};



// WEBPACK FOOTER //
// ./src/modules/user/constants.js